import { Alias } from './aliases';

export class KeyMapper {
  readonly #mapInternal: Map<string, string>;
  readonly #mapExternal: Map<string, string>;

  constructor(aliases: Alias[]) {
    if (
      !Array.isArray(aliases) ||
      !aliases.every(
        (x) =>
          x && typeof x.internal === 'string' && typeof x.external === 'string'
      )
    ) {
      throw new Error(
        'Mapping must be an array of Alias objects with internal and external properties'
      );
    }
    this.#mapInternal = new Map();
    this.#mapExternal = new Map();

    for (const { internal, external } of aliases) {
      this.#mapInternal.set(internal, external);
      this.#mapExternal.set(external, internal);
    }
  }

  toExternal(key: string): string {
    return this.#mapInternal.get(key) ?? key;
  }

  toInternal(key: string): string {
    return this.#mapExternal.get(key) ?? key;
  }

  add(internal: string, external: string): void;
  add(alias: Alias): void;
  add(internalOrAlias: string | Alias, external?: string): void {
    let internalValue: string;
    let externalValue: string;
    if (typeof internalOrAlias === 'string') {
      if (typeof external !== 'string') {
        throw new Error('External key must be a string');
      }

      internalValue = internalOrAlias;
      externalValue = external;
    } else {
      internalValue = internalOrAlias.internal;
      externalValue = internalOrAlias.external;
    }

    this.#mapInternal.set(internalValue, externalValue);
    this.#mapExternal.set(externalValue, internalValue);
  }
}
